import { ConditionFilterModel } from '@leverege/molten/filters';
import { FilterConditionFilterConverter } from '@leverege/molten/imagine';
import { Plugins } from '@leverege/plugin';
import { Attributes } from '@leverege/ui-attributes';
import OpenApiGroupDelegate from "../../delegates/openApi/OpenApiGroupDelegate.js";
import ConditionFilterModelConfigurer from "./ConditionFilterModelConfigurer.js";
export default {
  install(molten) {
    molten.addPlugin('ConditionFilterModel', {
      delegateType: OpenApiGroupDelegate.TYPE,
      ...ConditionFilterModel
    });
    molten.addPlugin('ConditionFilterModelConfigurer', ConditionFilterModelConfigurer);

    // support some sequelize out of the box
    molten.addPlugin('OpenApiConditionFilterConverter', {
      type: 'sequelize',
      factory: Plugins.createFactory('SequelizeConditionFilterConverter', {
        pluginKey: 'convert'
      })
    });
    molten.addPlugin('SequelizeConditionFilterConverter', FilterConditionFilterConverter);
    molten.addPlugin('SequelizeConditionFilterConverter', {
      type: 'condition.Logical',
      convert: (value, context) => {
        const {
          filterConverterFactory
        } = context;
        const conditions = value.conditions.map(c => filterConverterFactory.create(c, context)).filter(c => c != null);
        return conditions?.reduce((reducer, curr) => {
          return {
            ...reducer,
            ...curr
          };
        }, {});
      }
    });
    molten.addPlugin('SequelizeConditionFilterConverter', {
      type: 'condition.Attribute',
      convert: (value, context) => {
        const {
          attrName
        } = value;
        const {
          objectType,
          comparatorConverterFactory
        } = context;
        const attribute = Attributes.getAttribute(attrName, objectType);
        if (!value?.comparator) {
          return null;
        }
        return comparatorConverterFactory.create(value.comparator, attribute, context);
      }
    });
    molten.addPlugin('OpenApiComparatorFilterConverterFactory', {
      type: 'sequelize',
      factory: Plugins.createFactory('SequelizeComparatorFilterConverter', {
        pluginKey: 'convert'
      })
    });
    molten.addPlugin('SequelizeComparatorFilterConverter', {
      type: 'boolean.True',
      convert: (cmp, attribute) => {
        return {
          [attribute?.path]: true
        };
      }
    });
    molten.addPlugin('SequelizeComparatorFilterConverter', {
      type: 'boolean.False',
      convert: (cmp, attribute) => {
        return {
          [attribute?.path]: false
        };
      }
    });
    molten.addPlugin('SequelizeComparatorFilterConverter', {
      type: 'string.Equals',
      convert: (cmp, attribute) => {
        return {
          [attribute?.path]: cmp.value1
        };
      }
    });
  }
};